import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from '../../UI/Buttons';
import { Text } from '../../UI/Typography';
import { FaTimes, FaSpinner, FaUser } from 'react-icons/fa';
import { getDepartmentEmployees } from '../../../Services/Api/departmentService';
import { usePopup } from '../../../Popups/PopupContext';

const DepartmentsEmployee = ({ isOpen, onClose, department }) => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const { showError } = usePopup();

  useEffect(() => {
    if (isOpen && department?.dep_id) fetchEmployees();
  }, [isOpen, department?.dep_id]);

  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const data = await getDepartmentEmployees(department.dep_id);
      setEmployees(data || []);
    } catch (err) {
      showError('Failed to load members', err.message || String(err));
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
        style={{ position: 'fixed', top:0,left:0,right:0,bottom:0, background: 'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          onClick={(e)=>e.stopPropagation()}
          style={{ background: 'white', borderRadius:12, padding:20, maxWidth:700, width:'90%', maxHeight:'80vh', overflow:'auto' }}
        >
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
            <div>
              <Text variant="h2" style={{ margin:0 }}>{department?.dep_name || 'Members'}</Text>
              <Text variant="body2" style={{ color:'#666' }}>{employees.length} member{employees.length!==1?'s':''}</Text>
            </div>
            <Button variant="ghost" size="small" onClick={onClose}><FaTimes /></Button>
          </div>

          {loading ? (
            <div style={{ padding:40, display:'flex', justifyContent:'center' }}><FaSpinner className="spin" size={28} /></div>
          ) : (
            <div style={{ display:'grid', gap:12 }}>
              {employees.length===0 ? (
                <Text style={{ textAlign:'center', color:'#999', padding:20 }}>No members</Text>
              ) : employees.map(emp => (
                <div key={emp.id || emp.user_id} style={{ display:'flex', gap:12, alignItems:'center', padding:12, border:'1px solid #eee', borderRadius:8 }}>
                  <div style={{ width:40,height:40,borderRadius:20, background:'#eee', display:'flex', alignItems:'center', justifyContent:'center' }}>
                    <FaUser />
                  </div>
                  <div style={{ flex:1 }}>
                    <Text style={{ margin:0, fontWeight:500 }}>{emp.first_name || emp.username || `User ${emp.id || emp.user_id}`}</Text>
                    {emp.email && <Text variant="body2" style={{ color:'#666' }}>{emp.email}</Text>}
                  </div>
                </div>
              ))}
            </div>
          )}

          <div style={{ display:'flex', justifyContent:'flex-end', marginTop:16 }}>
            <Button variant="secondary" onClick={onClose}>Close</Button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default DepartmentsEmployee;
